var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"asset-tag-view"},[(!_vm.cover)?_c('div',{staticClass:"cover"}):_vm._e(),_c('img',{attrs:{"src":_vm.conf.imgUrl}}),_c('span',[_vm._v(" "+_vm._s(_vm.conf.name))]),(_vm.badge)?_c('i',[_vm._v(_vm._s(_vm.badge))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }